import request from './request'

export const parentApi = {
  check(phone) {
    return request.post('/parent/auth/check', { phone })
  },
  setup(phone, password) {
    return request.post('/parent/auth/setup', { phone, password })
  },
  login(phone, password) {
    return request.post('/parent/auth/login', { phone, password })
  },
  logout() {
    return request.post('/parent/auth/logout')
  },
  changePassword(oldPw, newPw) {
    return request.post('/parent/auth/change-password', { old: oldPw, new: newPw })
  },
  me() {
    return request.get('/parent/me')
  },
  lessons(studentId) {
    return request.get(`/parent/students/${studentId}/lessons`)
  },
  report(studentId, sessionId, lessonIndex) {
    return request.get(`/parent/reports/${studentId}/${sessionId}/${lessonIndex}`)
  },
  scores(studentId) {
    return request.get(`/parent/students/${studentId}/scores`)
  },
  videos(studentId) {
    return request.get(`/parent/students/${studentId}/videos`)
  },
  playVideo(studentId, videoId) {
    return request.get(`/parent/students/${studentId}/videos/${videoId}/play`)
  },
  resolveVideoShare(token) {
    return request.get(`/parent/video-shares/${token}/resolve`)
  },
  resolveVideoFolderShare(token) {
    return request.get(`/parent/video-folder-shares/${token}/resolve`)
  },
  scoreDetail(recordId) {
    return request.get(`/parent/scores/${recordId}`)
  },
  getHomework(studentId, sessionId, lessonIndex) {
    return request.get(`/parent/homework/${studentId}/${sessionId}/${lessonIndex}`)
  },
  submitHomework(formData) {
    return request.post('/parent/homework', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },
  submitHomeworkCorrection(formData) {
    return request.post('/parent/homework/correction', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },
  resolveShare(token, studentId) {
    // 不带 studentId：返回该手机号下报读该课程/班型的孩子候选（扫码多孩选择用）
    return request.get(`/parent/shares/${token}/resolve`, studentId ? { params: { studentId } } : undefined)
  }
}
